import React, { useEffect } from "react";
import { Box, Container, useMediaQuery, useTheme } from "@mui/material";
import SimpleBox from "../../components/layout/container/SimpleBox";
import PersonCard from "../../components/dataitem/PersonCard";
import { echelonMemberPositionMap, echelonMemberRoleMap } from "../../helpers/mapping";
import Title from "../../components/typography/Title";
import PageContent from "../../components/layout/container/PageContent";
import EchelonSelect from "../../components/input/select/EchelonSelect";
import ShadowBox from "../../components/layout/container/ShadowBox";
import SeasonSelect from "../../components/input/select/SeasonSelect";
import { apiPublicTeam } from "../../api/public";

const Team = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [season, setSeason] = React.useState(null);
    const [echelons, setEchelons] = React.useState([]);
    const [selectedEchelon, setSelectedEchelon] = React.useState(null);

    const positionMap = echelonMemberPositionMap().reduce((map, obj) => { map[obj.id] = obj.label; return map; }, {});
    const roleMap = echelonMemberRoleMap().reduce((map, obj) => { map[obj.id] = {label: obj.label, order: obj.order}; return map; }, {});

    useEffect(() => {
        if (Boolean(season)) {
            apiPublicTeam({ seasonId: season.id }, (data, successFlag) => {
                if (successFlag > 0) {
                    setEchelons(data.echelons);
                    const defaultEchelon = data.echelons.find(echelon => echelon.isDefault);
                    setSelectedEchelon(defaultEchelon?.id);
                }
            })
        }
    }, [season]);

    const echelonOptions = echelons.map(echelon => ({ id: echelon.id, label: echelon.name }));
    const subTitle = echelonOptions.find(item => item.id === selectedEchelon)?.label;
    const members = echelons.find(echelon => echelon.id === selectedEchelon)?.members ?? [];
    const imageSource = echelons.find(echelon => echelon.id === selectedEchelon)?.photoUrl;

    const membersCategory = [
        {
            isAthlete: true,
            label: "Atletas",
            members: members.filter(member => member.role === "PLAYER").sort((a, b) => a.name.localeCompare(b.name)),
        },
        {
            isAthlete: false,
            label: "Staff",
            members: members.filter(member => member.role !== "PLAYER").sort((a, b) => {
                if (a.role === b.role) return a.name.localeCompare(b.name);
                const roleOrderA = roleMap[a.role].order;
                const roleOrderB = roleMap[b.role].order;
                return roleOrderA - roleOrderB;
            }),
        },
    ];

    return (
        <PageContent title="Plantel" subTitle={subTitle} imageSource={imageSource}>
            <Container maxWidth="xl">
                <ShadowBox mt={6} padding={3}>
                    <SimpleBox
                        flexDirection={isMobile ? "column" : "row"}
                        alignItems={isMobile ? "stretch" : "center"}
                        justifyContent="flex-start"
                        flexWrap="wrap"
                        gap={4}
                    >
                        <Box sx={{ minWidth: 160, width: isMobile ? "100%" : 180 }}>
                            <SeasonSelect
                                flagParameter="hasMembers"
                                onSeasonChange={setSeason}
                            />
                        </Box>
                        <EchelonSelect
                            echelonOptions={echelonOptions}
                            selected={selectedEchelon}
                            onChange={(newValue) => setSelectedEchelon(newValue)} />
                    </SimpleBox>
                </ShadowBox>
                {
                    membersCategory.map((category, categIdx) => {
                        const forceSubtitleSpace = category.isAthlete ? (
                            category.members.filter(member => Boolean(member.position)).length > 0
                        ) : category.members.filter(member => Boolean(member.role)).length > 0;
                        return (
                            category.members.length > 0 ? (
                                <Box key={categIdx} mt={theme.spacing(6)}>
                                    <Title label={category.label} textAlign="center" pl={20} fontWeight="bold" />
                                    <SimpleBox mt={10} justifyContent="center" flexWrap="wrap" gap={4}>
                                        {
                                            category.members.map((member, memberIdx) => {
                                                const subtitle = category.isAthlete ? positionMap[member.position] : roleMap[member.role].label;
                                                return (
                                                    <PersonCard
                                                        key={memberIdx}
                                                        name={member.name}
                                                        gender={member.gender}
                                                        photoUrl={member.photoUrl}
                                                        forceSubtitleSpace={forceSubtitleSpace}
                                                        subtitle={subtitle}
                                                    />
                                                )
                                            })
                                        }
                                    </SimpleBox>
                                </Box>
                            ) : null
                        )
                    })
                }
            </Container>
        </PageContent>
    );
}

export default Team;
